import React from "react";
import Toggle from "../../../../../Forms/Toggle";
import { Text } from "@fluentui/react";
import ClientDropdown from "../Forms/ClientDropdown";
import CobrandTagsDropdown from "../Forms/CobrandTagsDropdown";
import CobrandDropDown from "../Forms/CobrandDropDown";
import { useFormikContext } from "formik";

const OnOffSettingsFields = ({ }) => {
    const { values, setFieldValue } = useFormikContext();

    const isGlobalOn = values.onOff;

    return (
        <>
            <Toggle
                name="onOff"
                label="Notification Global Setting"
                onText="Notification is on for all"
                offText="Notification is off for all"
                checked={isGlobalOn}
                onChange={(e, checked) => {
                    setFieldValue("onOff", checked);
                }}
            />
            <Text variant="small">
                If the notification is {isGlobalOn ? "on" : "off"} globally, then you can
                set the exceptions below.
            </Text>
            <ClientDropdown
                name={"clients"}
                label={`${isGlobalOn ? "OFF" : "ON"} for Clients`}
                multiSelect
                value={values.clients}
                onChange={(selected) => setFieldValue("clients", selected)}
            />
            <CobrandTagsDropdown
                name="coBrandTags"
                label={`${isGlobalOn ? "OFF" : "ON"} for Cobrand Tags`}
                multiSelect
                value={values.coBrandTags}
                onChange={(selected) => setFieldValue("coBrandTags", selected)}
            />
            <CobrandDropDown
                name={"coBrands"}
                label={`${isGlobalOn ? "OFF" : "ON"} for Cobrand`}
                byNameOrId="id"
                multiSelect
                value={values.coBrands}
                onChange={(selected) => setFieldValue("coBrands", selected)}
            />
        </>
    );
};

export default OnOffSettingsFields;
